import React from 'react';
import './Give.css';

const Give: React.FC = () => {
  return (
    <div className="give-page">
      <div className="give-hero">
        <div className="give-hero-content">
          <h1>Give</h1>
          <p className="hero-subtitle">Supporting the mission and ministry of Gener8ions Church</p>
        </div>
      </div>

      <div className="give-container">
        <section className="giving-intro">
          <h2>Why We Give</h2>
          <p>
            Giving is an act of worship and a way to participate in God's work. Your generous 
            contributions enable us to reach our community, support missions, and continue sharing 
            the love of Christ with all generations.
          </p>
        </section>

        <div className="giving-methods">
          <div className="giving-card">
            <div className="giving-icon">
              <img
                src="/images/Givelify_Logo_New2020_Standard_TwoColor_RGB.png"
                alt="Givelify"
                className="giving-logo"
              />
            </div>
            <h3>Givelify</h3>
            <p>Give securely online through Givelify</p>
            <a 
              href="https://www.givelify.com/donate/MTUyMjM5NA==/selection" 
              target="_blank" 
              rel="noopener noreferrer"
              className="give-btn btn-primary"
            >
              Give with Givelify
            </a>
          </div>

          <div className="giving-card">
            <div className="giving-icon">💰</div>
            <h3>CashApp</h3>
            <p>Send your donation via CashApp</p>
            <div className="cashapp-info">
              <p className="cashapp-handle">$gener8ionschurch</p>
              <a 
                href="https://cash.app/$gener8ionschurch" 
                target="_blank" 
                rel="noopener noreferrer"
                className="give-btn btn-primary"
              >
                Open CashApp
              </a>
            </div>
          </div>

          <div className="giving-card">
            <div className="giving-icon">📍</div>
            <h3>In Person</h3>
            <p>Give during our Sunday or Wednesday services</p>
            <p className="location-info">9644 Maumelle Blvd<br />North Little Rock, AR 72113</p>
          </div>

          <div className="giving-card">
            <div className="giving-icon">📧</div>
            <h3>Contact Us</h3>
            <p>Have questions about giving? We're here to help</p>
            <a href="/contact" className="give-btn btn-outline">
              Contact Us
            </a>
          </div>
        </div>

        <section className="giving-info">
          <div className="info-grid">
            <div className="info-card">
              <h3>Ways to Give</h3>
              <ul>
                <li>One-time gifts</li>
                <li>Recurring donations</li>
                <li>Tithes and offerings</li>
                <li>Special projects and missions</li>
              </ul>
            </div>

            <div className="info-card">
              <h3>Tax Information</h3>
              <p>
                Gener8ions Church is a 501(c)(3) organization. All donations are tax-deductible 
                to the extent allowed by law. You will receive a giving statement for your records.
              </p>
            </div>
          </div>
        </section>

        <section className="scripture-section">
          <blockquote>
            "Each of you should give what you have decided in your heart to give, not reluctantly 
            or under compulsion, for God loves a cheerful giver."
            <cite>— 2 Corinthians 9:7</cite>
          </blockquote>
        </section>
      </div>
    </div>
  );
};

export default Give;

